

































































































import { Vue, Component } from 'vue-property-decorator';
import SaleSummary from '@/components/root/SaleSummary.vue';
import DownloadManuals from '@/components/root/DownloadManuals.vue';
import QuestionSummary from '@/components/root/QuestionSummary.vue';
import ClaimSummary from '@/components/root/ClaimSummary.vue';
import DelaySummary from '@/components/root/DelaySummary.vue';
import ProductSummary from '@/components/root/ProductSummary.vue';
import ArticleTabList from '@/components/root/ArticleTabList.vue';
import ArticleList from '@/components/root/ArticleList.vue';
import { BoardCode, CosBoardsBoardCodeSummary, GetCosBoardsBoardCodeSummaryRequest } from 'ncp-api-supporter';
import CosPopup from '@/components/CosPopup.vue';
import { cosSectionCode } from '@/const/contents/cosSection';
import '@ncds/ui-admin/dist/ui-admin/assets/styles/style.css';

const { VUE_APP_COMMERCE_MAIN, VUE_APP_API_UPDATE_SHOPBY_NO } = process.env;

@Component({
  components: {
    ProductSummary,
    DelaySummary,
    ClaimSummary,
    QuestionSummary,
    DownloadManuals,
    SaleSummary,
    ArticleTabList,
    ArticleList,
    CosPopup,
  },
  computed: {
    cosSectionCode() {
      return cosSectionCode;
    },
  },
})

export default class Home extends Vue {
  /**
   * 게시판 번호들은 알파/리얼 하드코딩으로 처리한다
   * 참고: https://nhnent.dooray.com/project/tasks/3849582055670506077#comment-4016236460470014273
   */
  private readonly CATEGORY_NO = {
    NOTICE_PRIMARY_NO: 34,
    NOTICE_COMMON_NO: 42,
    NOTICE_SHOPBY_NO: 37,
    UPDATE_PRIMARY_NO: 35,
    UPDATE_SHOPBY_NO: 40,
    SELLER_TIP_NO: 81,
    API_UPDATE_SHOPBY_NO: Number(VUE_APP_API_UPDATE_SHOPBY_NO),
  }

  private readonly link = {
    news:VUE_APP_COMMERCE_MAIN + '/support/board?secondaryCategoryNo=0&primaryCategoryNo=0',
    notice: VUE_APP_COMMERCE_MAIN + `/support/board?primaryCategoryNo=${this.CATEGORY_NO.NOTICE_PRIMARY_NO}&secondaryCategoryNo=${this.CATEGORY_NO.NOTICE_SHOPBY_NO}`,
    upgrade: VUE_APP_COMMERCE_MAIN + `/support/board?primaryCategoryNo=${this.CATEGORY_NO.UPDATE_PRIMARY_NO}&secondaryCategoryNo=${this.CATEGORY_NO.UPDATE_SHOPBY_NO}`,
    faq: VUE_APP_COMMERCE_MAIN + '/customer/faq-list.gd?link=gnb2_3&category=&page=1&category=shopbypro',
    // 셀러팁 전체보기: 카테고리로 필터링된 목록 페이지
    sellerTip: VUE_APP_COMMERCE_MAIN + `/main/class?categoryNo=${this.CATEGORY_NO.SELLER_TIP_NO}`,
    // 셀러팁 개별 게시물: viewPath가 뒤에 붙으므로 쿼리스트링 없는 base를 사용한다
    sellerTipArticle: VUE_APP_COMMERCE_MAIN + '/main/class',
  };

  private noticeList: CosBoardsBoardCodeSummary[] = [];
  private upgradeList: CosBoardsBoardCodeSummary[] = [];
  private sellerTipList: CosBoardsBoardCodeSummary[] = [];
  private isMasterNotCommerceAccount = false;

  // private async fetchIsMasterNotCommerceAccount() {
  //   const { data } = await this.$api.getManagerInfo();
  //   return !data?.commerceAccount && data?.role === 'MASTER';
  // }

  created() {
    this.fetchArticles();
  }

  mounted() {
    // alert는 렌더링을 막으므로, 화면이 실제로 그려진 뒤에 띄운다
    this.$nextTick(() => requestAnimationFrame(() => setTimeout(this.handleContinueAction)));
  }

  private handleContinueAction() {
    const { continueAction, mallNo, ...rest } = this.$route.query;
    this.$router.replace({ query: rest }).catch(() => undefined);

    if (continueAction === 'redirectToSmsMigration') {
      alert('발신관리책임자 등록 또는 발신번호이관이 필요합니다.\n등록페이지로 이동합니다.');
      this.$router.push({ path: '/member/message/config', query: { mallNo } });
    } else if (continueAction === 'alertSmsMigration') {
      alert('발신관리책임자 등록 또는 발신번호이관이 필요합니다.\n대표운영자에게 요청해주세요.');
    }
  }

  private async fetchArticles() {
    const { NOTICE_COMMON_NO, NOTICE_SHOPBY_NO, UPDATE_SHOPBY_NO, SELLER_TIP_NO, API_UPDATE_SHOPBY_NO } = this.CATEGORY_NO;

    this.noticeList = await this.getArticles([NOTICE_COMMON_NO, NOTICE_SHOPBY_NO].join(','));
    this.upgradeList = await this.getArticles([UPDATE_SHOPBY_NO, API_UPDATE_SHOPBY_NO].join(','));
    this.sellerTipList = await this.getArticles(SELLER_TIP_NO.toString(), 'COMMERCE_CLASS' as BoardCode);
  }

  private getArticles = async (categoryNos: string, boardCode: BoardCode = 'COMMERCE_NEWS') => {
    const { data } = await this.$commerceApi.getCosBoardsBoardCodeSummary({
      pathParams: {
        boardCode,
      },
      params: {
        size: 7,
        categoryNos,
        // 공지사항/업데이트·셀러팁 모두 상단 고정 게시물을 우선 노출한다
        isTopFixedFirst: true
      } as GetCosBoardsBoardCodeSummaryRequest['params'] & { isTopFixedFirst?: boolean }
    });

    return data;
  }
}
